import { fetcher } from "helpers/fetcher";

import {
  TUpdateOrganizationInvoiceReq,
  TUpdateOrganizationInvoiceRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateOrganizationInvoice = async (
  payload: TUpdateOrganizationInvoiceReq
) => {
  return await fetcher<
    TUpdateOrganizationInvoiceRes,
    TUpdateOrganizationInvoiceReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_ORGANIZATION_INVOICE, {
    data: {
      idBusinessEstablishment: payload.data.idBusinessEstablishment,
      invoiceType: payload.data.invoiceType,
      organization: payload.data.organization,
    },
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_ORGANIZATION_INVOICE.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateOrganizationInvoice = async (
  payload: TUpdateOrganizationInvoiceReq
) => {
  return (await updateOrganizationInvoice(payload)).data;
};

mutationUpdateOrganizationInvoice._key = (
  payload: TUpdateOrganizationInvoiceReq
) => [ENDPOINT.CORPORATION.UPDATE_ORGANIZATION_INVOICE.url, payload];
